'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPersonaddOutline = function IoIosPersonaddOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 12v1h-2v2h-1v-2h-2v-1h2v-2h1v2h2z m-16.7 3.8z m12.6 12.6c1 0.4 4.1 1.6 4.1 4.1h-25c0-2.5 3.1-3.7 4.1-4.1s2.5-0.4 3.4-0.7c0.5-0.1 1.3-0.4 1.6-0.7s0-3.2 0-3.2-0.4-0.8-0.7-1.4-0.5-2.5-0.5-2.5-0.6 0-0.7-0.9c-0.2-1-0.5-1.3-0.5-2.1 0-0.7 0.4-0.8 0.4-0.8s-0.3-1-0.4-3.3c-0.1-2.6 2-5.3 5.8-5.3s5.9 2.7 5.8 5.3c-0.1 2.3-0.4 3.3-0.4 3.3s0.4 0.1 0.4 0.8c0 0.8-0.3 1.1-0.5 2.2-0.1 0.9-0.7 0.9-0.7 0.9s-0.3 1.8-0.5 2.4-0.7 1.4-0.7 1.4-0.2 2.9 0 3.2 1.1 0.6 1.6 0.7c0.9 0.3 2.3 0.3 3.4 0.7z m-8.4 2.9h10.7c-0.2-0.3-0.3-0.5-0.6-0.7-0.6-0.4-1.3-0.7-2.1-1-0.6-0.1-1.4-0.3-2.1-0.4-0.4-0.1-0.7-0.1-1.1-0.2-0.3-0.1-1.7-0.4-2.3-1.2-0.3-0.4-0.5-0.9-0.5-2.5 0-0.8 0.1-1.6 0.1-1.6v-0.3l0.2-0.3c0-0.1 0.4-0.7 0.6-1.2 0.1-0.3 0.4-1.4 0.5-2.1 0 0 0 0 0-0.4s0.7-0.3 0.7-0.6 0.3-0.5 0.4-1.4-0.4-0.9-0.4-1.3c0-0.3 0.1-0.4 0.1-0.4 0-0.1 0.3-1.1 0.3-3 0-1-0.4-2-1.1-2.7-0.8-0.9-1.9-1.3-3.4-1.3-1.4 0-2.7 0.4-3.5 1.3-0.7 0.7-1 1.7-1 2.7 0 1.9 0.3 2.9 0.3 3s0.1 0.2 0 0.5c-0.1 0.4-0.5 0.4-0.3 1.2s0.3 1.1 0.4 1.4 0.6 0.3 0.7 0.6 0 0.4 0 0.4c0.1 0.7 0.4 1.8 0.5 2.1 0.2 0.5 0.5 1.1 0.6 1.2l0.2 0.3v0.3s0.1 0.8 0.1 1.6c0 1.6-0.2 2.1-0.5 2.5-0.6 0.8-2 1.1-2.3 1.2-0.4 0.1-0.7 0.1-1.2 0.2-0.7 0.1-1.4 0.3-2 0.4-0.8 0.3-1.5 0.6-2.1 1-0.3 0.2-0.5 0.4-0.6 0.6h10.7z' })
        )
    );
};

exports.default = IoIosPersonaddOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-personadd-outline.js
// module id = 2474
// module chunks = 0